import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ELearningManagementService } from '../../e-learning-management/e-learning-management.service';
import { ModalSkillTreeComponent } from '../modal-skill-tree/modal-skill-tree.component';
import { SkillTreeManagementService } from '../skill-tree-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-manage-skill-tree',
  templateUrl: './manage-skill-tree.component.html',
  styleUrls: ['./manage-skill-tree.component.scss']
})
export class ManageSkillTreeComponent implements OnInit {
  level = ['INFORMATIONEM', 'SCIENTIA', 'PREHENDERE', 'SAPIENTIA', 'PSYCHE']
  arrNode = {
    INFORMATIONEM: [],
    SCIENTIA: [],
    PREHENDERE: [],
    SAPIENTIA: [],
    PSYCHE: []
  }
  allTeacher;
  allCourse = [];
  _allCourse = [];
  oldAllCourse = [];
  selectedCourse = [];
  skillTreeForm: FormGroup;
  arrTeacherSelected = [];

  isViewOnly: boolean = false;
  isLoading: boolean;
  isEdit: boolean;
  skillTreeId: string;

  defaultNodes = [
    {
      id: 'INFORMATIONEM-1',
      label: 'INFORMATIONEM',
      tooltip: '',
      data: {
        customColor: '#ffffff00',
        customFontColor: '#ffffff',
      }
    }, {
      id: 'SCIENTIA-1',
      label: 'SCIENTIA',
      tooltip: '',
      data: {
        customColor: '#ffffff00',
        customFontColor: '#ffffff'
      }
    }, {
      id: 'PREHENDERE-1',
      label: 'PREHENDERE',
      tooltip: '',
      data: {
        customColor: '#ffffff00',
        customFontColor: '#ffffff'
      }
    }, {
      id: 'SAPIENTIA-1',
      label: 'SAPIENTIA',
      tooltip: '',
      data: {
        customColor: '#ffffff00',
        customFontColor: '#ffffff'
      }
    }, {
      id: 'PSYCHE-1',
      label: 'PSYCHE',
      tooltip: '',
      data: {
        customColor: '#ffffff00',
        customFontColor: '#ffffff'
      }
    }
  ];

  defaultLinks = [
    {
      source: 'INFORMATIONEM-1',
      target: 'SCIENTIA-1',
      data: {
        color: '#ffffff00',
        customColor: '#ffffff00'
      }
    }, {
      source: 'SCIENTIA-1',
      target: 'PREHENDERE-1',
      data: {
        color: '#ffffff00',
        customColor: '#ffffff00'
      }
    }, {
      source: 'PREHENDERE-1',
      target: 'SAPIENTIA-1',
      data: {
        color: '#ffffff00',
        customColor: '#ffffff00'
      }
    }, {
      source: 'SAPIENTIA-1',
      target: 'PSYCHE-1',
      data: {
        color: '#ffffff00',
        customColor: '#ffffff00'
      }
    }
  ];

  defaultClusters = [
    {
      id: 'INFORMATIONEM',
      label: '',
      childNodeIds: ['INFORMATIONEM-1'],
      data: {
        customColor: '#A2BBEE'
      }
    },
    {
      id: 'SCIENTIA',
      label: '',
      childNodeIds: ['SCIENTIA-1'],
      data: {
        customColor: '#9EA3DC'
      }
    },
    {
      id: 'PREHENDERE',
      label: '',
      childNodeIds: ['PREHENDERE-1'],
      data: {
        customColor: '#9D8BC7'
      }
    },
    {
      id: 'SAPIENTIA',
      label: '',
      childNodeIds: ['SAPIENTIA-1'],
      data: {
        customColor: '#9C72AE'
      }
    },
    {
      id: 'PSYCHE',
      label: '',
      childNodeIds: ['PSYCHE-1'],
      data: {
        customColor: '#9A5991'
      }
    }
  ]

  nodes = [];
  links = [];
  clusters = [];

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private elearningManagementService: ELearningManagementService,
    private skillTreeManagementService: SkillTreeManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));

    if (!this.isEdit) {
      this.gobalFunctionService.setTitle('สร้าง Skill Tree');

      this.skillTreeForm = this.fb.group({
        name: ['', Validators.required],
        teachers: [[], Validators.required],
      })

      this.nodes = [...this.defaultNodes];
      this.links = [...this.defaultLinks];

      // clone array object
      this.clusters = JSON.parse(JSON.stringify(this.defaultClusters));
      this.clusters = [...this.clusters];
    } else {
      this.skillTreeId = new URL(location.href).searchParams.get('skilltree_id');

      this.skillTreeManagementService.getDetailSkillTree(this.skillTreeId).subscribe(res => {
        // // console.log(res.result[0]);

        let teacherArr = res.result[0].TEACHER_ID.split(',');
        this.isViewOnly = res.result[0].VIEW_ONLY;

        if (this.isViewOnly) {
          this.gobalFunctionService.setTitle('ดู Skill Tree');
        } else {
          this.gobalFunctionService.setTitle('แก้ไข Skill Tree');
        }

        this.skillTreeForm = this.fb.group({
          name: [res.result[0].TREE_NAME, Validators.required],
          teachers: [teacherArr, Validators.required],
        })

        this.arrNode = res.result[0].NODES_SELECTION;
        // แยก selected course
        this.level.map(lv => this.arrNode[lv].map(node => this.selectedCourse.push(node)));

        this.clusters = [...res.result[0].CLUSTER_NODES];
        this.nodes = [...res.result[0].NODES];
        this.links = [...res.result[0].LINKS];

        this.refreshCenter();
      }, error => alert(error.error.message))
    }

    this.elearningManagementService.getActiveTeacher().subscribe(res => {
      this.allTeacher = res.result;
    })
  }

  createNode(level) {
    // // console.log(level);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalAddNode';
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'เลือกคอร์สเรียน',
      actionBtnText: 'บันทึก',
      level: level,
      isEdit: false,
      allCourse: this.allCourse,
      teachers: this.skillTreeForm.value.teachers
    };

    const modal = this.matDialog.open(ModalSkillTreeComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status) {
          let index = this.clusters.findIndex(c => c.id === res.level)
          // // console.log(res);

          this.arrNode[level].push(res.data);
          this.nodes.push(res.data);
          this.nodes = [...this.nodes];

          if (this.clusters[index]?.childNodeIds.length > 0) {
            this.clusters[index]?.childNodeIds.push(res.data.id);
          }

          this.clusters = [...this.clusters];
          this.selectedCourse.push(res.data);
          this.fetchCourse();
          // // console.log(this.arrNode);
        }
      })
    ).subscribe()
  }

  getSelectedItem(t) {
    // // console.log(t);

    const body = {
      TEACHER_ID: t
    }

    if (t.length > 0) {
      this.skillTreeManagementService.skilltreeCourseList(body).subscribe(res => {
        let lostCourse = []
        this.allCourse = this._allCourse = res.result;

        if (this.isEdit && !this.oldAllCourse) {
          this.oldAllCourse = JSON.parse(JSON.stringify(this.allCourse));
        }

        if (this.oldAllCourse?.length > 0 || this.isEdit) {
          this.oldAllCourse.map(oc => {
            let course = this.allCourse.map(c => c.COURSE_ID).indexOf(oc.COURSE_ID);

            if (course === -1)
              lostCourse.push(oc);
          });

          this.removeAboutSkillTree(lostCourse);
        }
        this.oldAllCourse = JSON.parse(JSON.stringify(this.allCourse));

        if (this.selectedCourse.length > 0)
          this.fetchCourse();
      })
    } else {
      // clear value and set default nodes, links, clusters
      let c = JSON.parse(JSON.stringify(this.defaultClusters));

      this.level.forEach(lv => {
        for (let i = 0; i < this.arrNode[lv].length; i++)
          this.arrNode[lv] = [];
      })

      this.allCourse = null;
      this.selectedCourse = [];
      this.nodes = [...this.defaultNodes];
      this.links = [...this.defaultLinks];
      this.clusters = [...c];
    }
  }

  editNode(n, i, j, level) {
    // // console.log(n);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalEditNode';
    dialogConfig.width = '500px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: n.label,
      actionBtnText: 'บันทึก',
      level: level,
      availableLevel: this.level.slice(i + 1, this.level.length),
      nodeIndex: j,
      isEdit: true,
      node: n,
      links: this.links,
      arrayNode: this.arrNode
    };

    const modal = this.matDialog.open(ModalSkillTreeComponent, dialogConfig);
    modal.afterClosed().pipe(
      map(res => {
        if (res.status && !res.delete) {
          // // console.log(res.data);

          this.links = this.links.filter(l => l.source !== n.id);

          res.data.map(l => {
            this.links.push(l);
          })
          this.nodes = [...this.nodes];
          this.links = [...this.links];
        }

        if (res.status && res.delete) {
          // // console.log(res.data);

          this.removeAboutSkillTree([{ COURSE_ID: res.data }])
        }
      })
    ).subscribe()
  }

  removeAboutSkillTree(listCouse) {
    listCouse.map(c => {
      this.nodes = this.nodes.filter(n => n.id !== c.COURSE_ID);
      // // console.log(this.nodes);

      this.level.map(l => this.arrNode[l] = this.arrNode[l].filter(nr => nr.id !== c.COURSE_ID));
      // // console.log(this.arrNode);

      this.clusters.map((ct, i) => this.clusters[i].childNodeIds = ct.childNodeIds.filter(n => n !== c.COURSE_ID));
      // // console.log(this.clusters);

      this.links = this.links.filter(l => l.source !== c.COURSE_ID && l.target !== c.COURSE_ID);
      // // console.log(this.links);

      this.selectedCourse = this.selectedCourse.filter(sc => sc.id != c.COURSE_ID);
    })
    this.setAllCourse();
  }

  setAllCourse() {
    const body = {
      TEACHER_ID: this.skillTreeForm.value.teachers
    }

    this.skillTreeManagementService.skilltreeCourseList(body).pipe(
      map(res => {
        this.allCourse = res.result;
      }),
      map(() => {
        this.selectedCourse.map(sc => this.allCourse = this.allCourse.filter(oc => oc.COURSE_ID !== sc.id))
        // // console.log(this.allCourse);
      })
    ).subscribe()
  }

  createSkillTree(stForm) {
    // // console.log(stForm);

    let _clusters = [];
    let _links = [];
    let _nodes = [];

    this.clusters.map(c => {
      // // console.log(c);

      _clusters.push({
        id: c.id,
        label: '',
        childNodeIds: c.childNodeIds,
        data: {
          customColor: c.data.customColor,
          color: c.data.color
        },
      })
    })

    this.links.map(l => {
      _links.push({
        id: l.id,
        data: {
          customColor: l.data.customColor,
          color: l.data.color
        },
        source: l.source,
        target: l.target
      })
    })

    this.nodes.map(n => {
      _nodes.push({
        id: n.id,
        data: {
          customColor: n.data.customColor,
          customFontColor: n.data.customFontColor,
          color: n.data.color
        },
        label: n.label,
        tooltip: n.tooltip
      })
    })

    const body = {
      TREE_NAME: stForm.name,
      TEACHER_ID: stForm.teachers,
      CLUSTER_NODES: _clusters,
      LINKS: _links,
      NODES: _nodes,
      NODES_SELECTION: this.arrNode
    }
    // // console.log(body);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '400px';
    dialogConfig.data = {
      title: 'ยืนยันการสร้าง',
      description: `คุณต้องการสร้าง ${stForm.name} ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(confirm => {
        if (confirm) {
          return this.skillTreeManagementService.createSkilltree(body).pipe(
            switchMap(st => {
              this.isLoading = true;

              if (st.success) {
                this.isLoading = false;
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalSuccess';
                dialogConfig2.width = '400px';
                dialogConfig2.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">สร้าง ${stForm.name} สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig2);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close();
                      }, 100);
                    }
                  })
                )
              } else {
                this.isLoading = false;
                alert(`${st.message}`);
              }
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()


  }

  editSkillTree(stForm) {
    let _clusters = [];
    let _links = [];
    let _nodes = [];

    this.clusters.map(c => {
      _clusters.push({
        id: c.id,
        label: '',
        childNodeIds: c.childNodeIds,
        data: {
          customColor: c.data.customColor,
          color: c.data.color
        },
      })
    })

    this.links.map(l => {
      _links.push({
        id: l.id,
        data: {
          customColor: l.data.customColor,
          color: l.data.color
        },
        source: l.source,
        target: l.target
      })
    })

    this.nodes.map(n => {
      _nodes.push({
        id: n.id,
        data: {
          customColor: n.data.customColor,
          customFontColor: n.data.customFontColor,
          color: n.data.color
        },
        label: n.label,
        tooltip: n.tooltip
      })
    })

    const body = {
      TREE_ID: this.skillTreeId,
      TREE_NAME: stForm.name,
      TEACHER_ID: stForm.teachers,
      CLUSTER_NODES: _clusters,
      LINKS: _links,
      NODES: _nodes,
      NODES_SELECTION: this.arrNode
    }
    // // console.log(body);

    this.skillTreeManagementService.editSkillTreeById(body).pipe(
      switchMap(st => {
        this.isLoading = true;

        if (st.success) {
          this.isLoading = false;
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalSuccess';
          dialogConfig.width = '400px';
          dialogConfig.data = {
            title: 'สำเร็จแล้ว',
            description: `<img src="../../../assets/check.png" width="100px;" class="img-center">แก้ไข ${stForm.name} สำเร็จแล้ว`,
            cancleBtnText: 'ยืนยัน',
            customStyle: 'background-color: #58595B;'
          }

          const modal = this.matDialog.open(ModalComponent, dialogConfig);
          return modal.afterClosed().pipe(
            map(res => {
              if (!res) {
                window.opener.location.reload();
                setTimeout(() => {
                  window.close();
                }, 100);
              }
            })
          )
        } else {
          this.isLoading = false;
          alert(`${st.message}`);
        }
      })
    ).subscribe()
  }

  deleteSkillTree(id, name) {
    this.isLoading = true;
    const confirmDelete = new MatDialogConfig();

    confirmDelete.autoFocus = false;
    confirmDelete.id = 'modalDeleteNews';
    confirmDelete.data = {
      title: 'คุณต้องการลบ Skill Tree?',
      description: `ระบบจะทำการลบ "${name}" ออกจากระบบ คุณต้องการลบ ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      isDelete: true
    }

    const modal = this.matDialog.open(ModalComponent, confirmDelete);
    return modal.afterClosed().pipe(
      switchMap(isDelete => {
        if (isDelete) {
          const body = {
            TREE_ID: id
          }
          return this.skillTreeManagementService.delSkillTree(body).pipe(
            switchMap(res => {
              if (res.success) {
                this.isLoading = false;
                const dialogConfig = new MatDialogConfig();
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'ลบ Skill Tree สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ลบ "${name}" สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig);
                return modal.afterClosed().pipe(
                  map(res => {
                    if (!res) {
                      window.opener.location.reload();
                      setTimeout(() => {
                        window.close();
                      }, 100);
                    }
                  })
                )
              } else {
                alert(res.message);
                return of(null);
              }
            }),
            catchError((err) => {
              alert(err.error.message);
              this.isLoading = false;
              return of(null);
            }),
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      })
    ).subscribe()
  }

  refreshCenter() {
    setTimeout(() => {
      this.nodes = [...this.nodes];
      this.links = [...this.links];
      this.clusters = [...this.clusters];
    }, 800);
  }

  fetchCourse() {
    this.selectedCourse.map(sc => this.allCourse = this.allCourse.filter(ac => ac.COURSE_ID != sc.id));
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1 === i2 : i1 === i2;
  }

}
